<template>
  <div class="creat" v-if="show">
    <van-cell-group>
      <van-field
        disabled
        clearable
        required
        label="请假类型"
        type="text"
        right-icon="arrow"
        placeholder="请选择请假类型"
        v-model="leavetypeMsg"
        @click="showLeaveType"
      />
      <van-field
        disabled
        clearable
        required
        type="text"
        label="开始时间"
        right-icon="arrow"
        placeholder="开始时间"
        v-model="startMsg"
        @click="showStartDate"
      />
      <van-field
        disabled
        clearable
        required
        type="text"
        label="结束时间"
        v-model="endMsg"
        @click="showEndDate"
        right-icon="arrow"
        placeholder="结束时间"
      />
      <!-- <van-field clearable type="text" label="请假天数" v-model="dayNum" placeholder="请输入请假天数" /> -->
      <van-field
        clearable
        required
        type="textarea"
        v-model="description"
        label="请假原因"
        placeholder="请填写请假原因"
        maxlength="100"
        show-word-limit
      />
      <van-cell center title="请假图片" class="flexColumn">
        <template slot="default">
          <van-uploader v-model="fileList" :before-read="beforeRead" :after-read="postImg" :max-count="6" @delete="imgList_delete"></van-uploader>
        </template>
      </van-cell>

      <van-cell center title="审批流程" v-if="showFlow">
      </van-cell>
      <CreatFlow :data="barchData" v-if="showFlow"></CreatFlow>
    </van-cell-group>
    <van-popup v-model="leaveType" position="bottom" :style="{ height: '45%' }">
      <ul class="leaveType">
        <li v-for="(item,index) in leaveTypeData" :key="index" @click="checkType(item)">{{item.TeacherLeaveTypeName}}</li>
      </ul>
    </van-popup>
    <van-popup v-model="startDate" position="bottom" :style="{ height: '45%' }">
      <van-datetime-picker
        @cancel="cancelPicker"
        @confirm="confirmPickerStart"
        v-model="currentDate"
        type="datetime"
        :formatter="formatter"
      />
    </van-popup>
    <van-popup v-model="endDate" position="bottom" :style="{ height: '45%' }">
      <van-datetime-picker
        @cancel="cancelPicker"
        @confirm="confirmPickerEnd"
        v-model="currentDate"
        type="datetime"
        :formatter="formatter"
      />
    </van-popup>
    <SingleBottomBtn @clickBtn="create">提交</SingleBottomBtn>
  </div>
</template>
<script>
import SingleBottomBtn from "../../components/SingleBottomBtn";
import CreatFlow from "../../../../components/workFlow/CreatFlow";
import { Toast } from "vant";
import EXIF from 'exif-js'
export default {
  name: "create",
  components: {
    SingleBottomBtn,
    CreatFlow
  },
  data() {
    return {
      show: true,
      leaveType: false,
      leaveTypeData: [],
      leavetypeMsg: "",
      leaveId: 0,
      startDate: false,
      currentDate: new Date(), // 开始时间不能超过当前时间,
      startMsg: "",
      endDate: false,
      endMsg: "",
      dayNum: "",
      description: "",
      fileList: [],
      filesArr:[],
      userId: '',
      barchData: [11],
      showFlow:false,
      storeObj:this.$store.state.attendance.creatFlow,
      isBack:false, // 是否是选择抄送人回来的
      files: {
        name: "",
        type: ""
      },
      headerImage: null,
      picValue: null,
      upImgUrl: '',
    };
  },
  created() {
    this.barchData = this.storeBarData;

    this.GetUserInfo()
    if(this.$store.state.attendance.creatFlow) {
      var com = this.$store.state.attendance.creatFlow
      this.leavetypeMsg = com.leavetypeMsg
      this.leaveId = com.TeacherLeaveTypeID
      this.startMsg = com.StartTime
      this.endMsg = com.EndTime
      this.dayNum = com.dayNum
      this.description = com.ApplicationDescription
      this.fileList = com.LeavePictrueList
      this.showFlow= com.isShow
    }
  },

  computed: {
    leaveTeachers () {
      return this.$store.state.attendance.leaveTeachers
    },
    addCCIndex () {
      return this.$store.state.attendance.addCCIndex
    },
    storeBarData () {
      return this.$store.state.attendance.barData
    }

  },
  watch:{
    'showFlow':function(newV) {
      this.storeObj.isShow = newV
    },
    'leavetypeMsg':function(newV) {
      this.storeObj.leavetypeMsg = newV
    },
    'leaveId':function(newV) {
      this.storeObj.TeacherLeaveTypeID = newV
    },
    'startMsg':function(newV) {
      this.storeObj.StartTime = newV
    },
    'endMsg':function(newV) {
      this.storeObj.EndTime = newV
    },
    'dayNum':function(newV) {
      this.storeObj.dayNum = newV
    },
    'description':function(newV) {
      this.storeObj.ApplicationDescription = newV
    },
    'fileList':function(newV) {
      this.storeObj.LeavePictrueList = newV
    },

    'barchData': {
      deep: true,
      handler: function (newV) {
      console.log(newV)
      }
    },

  },
  methods: {
    // 用户
    async GetUserInfo() {
      let res = await this.xyapi.get(this.xyMApi + '/base' + "/api/Users/GetUserInfo");
      if (res.data) {
        this.userId = res.data.UserID;
      }
    },
    formatter(type, value) {
      // 格式化选择器日期
      if (type === "year") {
        return `${value}年`;
      } else if (type === "month") {
        return `${value}月`;
      }
      return value;
    },
    async showLeaveType() {
      let res = await this.xyapi.get(
        this.$store.state.apiPath + "/api/TeacherLeaveForMobile/GetAll"
      );
      if (res.success) {
        this.leaveTypeData = res.data;
        this.leaveType = true;
      }
    },
    checkType(e) {
      this.leavetypeMsg = e.TeacherLeaveTypeName;
      this.leaveId = e.TeacherLeaveTypeID;
      if (e) {
        this.leaveType = false;
      }
    },
    showStartDate() {
      this.startDate = true;
    },
    showEndDate() {
      this.endDate = true;
    },
    cancelPicker() {
      // 选择器取消按钮点击事件
      this.startDate = false;
      this.endDate = false;
    },
    confirmPickerStart(value) {
      // 确定按钮，时间格式化并显示在页面上
      var date = this.xy.moment(value).format('YYYY-MM-DD HH:mm');
      this.startMsg = date;
      this.startDate = false;
    },
    confirmPickerEnd(value) {
      var date = this.xy.moment(value).format('YYYY-MM-DD HH:mm');
      this.endMsg = date;
      this.endDate = false;
      let m1 = this.xy.moment(this.startMsg).format('YYYY-MM-DD');
      let m2 = this.xy.moment(date)
      this.dayNum = m2.diff(m1,'days')
      if (this.dayNum === 0 && this.xy.moment(this.startMsg).format('YYYY-MM-DD')!==this.xy.moment(this.endMsg).format('YYYY-MM-DD')) {
        Toast.fail('结束时间不早于开始时间！');
        this.barchData = []
        return
      } else if (this.dayNum === 0) {
        this.dayNum = 1
        this.getBarch()
      } else if (this.dayNum > 0) {
        this.dayNum = this.dayNum + 1
        this.getBarch()
      } else if (this.dayNum < 0 ) {
        Toast.fail('结束时间不早于开始时间！');
        this.barchData = []
      }
    },
    beforeRead(file){
      if (file.type !== 'image/jpeg'&&file.type !== 'image/jpg'&&file.type !== 'image/png') {
        this.xy.msgError('请上传 jpg/jpeg/png 格式图片')
        return false;
      }
      return true
    },
    // 上传图片
    async afterRead(file) {
      console.log(file)
      this.files.name = file.file.name; // 获取文件名
      this.files.type = file.file.type; // 获取类型
      this.picValue = file.file; // 文件流
      this.imgPreview(this.picValue);
    },

    // 处理图片
    imgPreview(file) {
      let self = this;
      let Orientation;
      //去获取拍照时的信息，解决拍出来的照片旋转问题
      EXIF.getData(file, function () {
        Orientation = EXIF.getTag(this, "Orientation")
      });
      // 看支持不支持FileReader
      if (!file || !window.FileReader) return;
      if (/^image/.test(file.type)) {
        // 创建一个reader
        let reader = new FileReader();
        // 将图片2将转成 base64 格式
        // reader.readAsDataURL(file);
        // 读取成功后的回调
        reader.onloadend = function () {
          let result = this.result;
          let img = new Image();
          img.src = result;
          //判断图片是否大于500K,是就直接上传，反之压缩图片
          if (this.result.length <= 500 * 1024) {
            self.headerImage = this.result;
            self.postImg();
          } else {
            img.onload = function () {
              let data = self.compress(img, Orientation);
              self.headerImage = data;
              self.postImg();
            };
          }
        };
      }
    },
    // 压缩图片
    compress(img, Orientation) {
      let canvas = document.createElement("canvas");
      let ctx = canvas.getContext("2d");
      //瓦片canvas
      let tCanvas = document.createElement("canvas");
      let tctx = tCanvas.getContext("2d");
      // let initSize = img.src.length;
      let width = img.width;
      let height = img.height;
      //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
      let ratio;
      if ((ratio = (width * height) / 4000000) > 1) {
        ratio = Math.sqrt(ratio);
        width /= ratio;
        height /= ratio;
      } else {
        ratio = 1;
      }
      canvas.width = width;
      canvas.height = height;
      //    铺底色
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      //如果图片像素大于100万则使用瓦片绘制
      let count;
      if ((count = (width * height) / 1000000) > 1) {
        count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
        //      计算每块瓦片的宽和高
        let nw = ~~(width / count);
        let nh = ~~(height / count);
        tCanvas.width = nw;
        tCanvas.height = nh;
        for (let i = 0; i < count; i++) {
          for (let j = 0; j < count; j++) {
            tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);
            ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
          }
        }
      } else {
        ctx.drawImage(img, 0, 0, width, height);
      }
      //修复ios上传图片的时候 被旋转的问题
      if (Orientation !== "" && Orientation !== 1) {
        switch (Orientation) {
          case 6: //需要顺时针（向左）90度旋转
            this.rotateImg(img, "left", canvas);
            break;
          case 8: //需要逆时针（向右）90度旋转
            this.rotateImg(img, "right", canvas);
            break;
          case 3: //需要180度旋转
            this.rotateImg(img, "right", canvas); //转两次
            this.rotateImg(img, "right", canvas);
            break;
        }
      }
      //进行最小压缩
      let ndata = canvas.toDataURL("image/jpeg", 0.1);
      tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
      return ndata;
    },
    // 旋转图片
    rotateImg(img, direction, canvas) {
      //最小与最大旋转方向，图片旋转4次后回到原方向
      const min_step = 0;
      const max_step = 3;
      if (img === null) return;
      //img的高度和宽度不能在img元素隐藏后获取，否则会出错
      let height = img.height;
      let width = img.width;
      let step = 2;
      if (step === null) {
        step = min_step;
      }
      if (direction === "right") {
        step++;
        //旋转到原位置，即超过最大值
        step > max_step && (step = min_step);
      } else {
        step--;
        step < min_step && (step = max_step);
      }
      //旋转角度以弧度值为参数
      let degree = (step * 90 * Math.PI) / 180;
      let ctx = canvas.getContext("2d");
      switch (step) {
        case 0:
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0);
          break;
        case 1:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(-degree);
          ctx.drawImage(img, 0, -height);
          break;
        case 2:
          canvas.width = width;
          canvas.height = height;
          ctx.rotate(-degree);
          ctx.drawImage(img, -width, -height);
          break;
        case 3:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(-degree);
          ctx.drawImage(img, -width, 0);
          break;
      }
    },
    //将base64转换为文件
    dataURLtoFile(dataurl) {
      var arr = dataurl.split(","),
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], this.files.name, {
        type: this.files.type
      });
    },
    //这里写接口
    async postImg(file) {
      // let file = this.dataURLtoFile(this.headerImage);
      let formData = new window.FormData();
      formData.append("file", file.file);
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };

      let res = await this.xyapi.post(
        this.$store.state.apiPath + "/api/TeacherLeaveForMobile/IconUpload",
        formData,
        config
      );

      if (res.success) {
        if (this.filesArr.length === 0) {
          this.filesArr = []
          this.filesArr.push({url: this.$store.state.apiPath + res.data.FilePath,upUrl: res.data.FilePath});
        } else {
          this.filesArr.push({url: this.$store.state.apiPath + res.data.FilePath,upUrl: res.data.FilePath});
        }
        this.fileList = []
        this.fileList = this.filesArr
      }
    },
    async getBarch() {
      let params = {
        ApplicantUserID: this.userId,
        OrganizationID: 0,
        WorkFlowType: 0,
        ConditionValues: [{ Type: 0, Code: 1, Value: this.dayNum }, { Type: 0, Code: 2, Value: 1 }]
      }
      this.xy.loading()
      let res = await this.xyapi.post(this.$store.state.apiPublic + '/api/WorkFlowSetting/ApprovalProcessByCondition', params);
      if(res.success){
        if(res.data) {
          this.showFlow = true
          this.barchData = []
          this.barchData = res.data

        }else{
          this.barchData = []
        }
      }else{
          this.barchData = []
      }
      this.xy.unloading()
    },
    async create() {
      if(!this.leavetypeMsg){
        Toast.fail("请假类型不能为空")
        return false
      }
      if(!this.description){
        Toast.fail("请假原因不能为空")
        return false
      }
      if(!this.startMsg){
        Toast.fail("开始时间不能为空")
        return false
      }
      if(!this.endMsg){
        Toast.fail("结束时间不能为空")
        return false
      }
      let arr = []
      let haveApr = false
      arr = this.barchData.map(item => {
        let apprpArr = []
        if(item.ApprovalMemberType!==0) {
          if (item.sureData) {
            apprpArr = item.sureData.map(i => {
              return i.UserID
            })
            haveApr = true
          } else{
            haveApr = false
            //Toast.fail("请设置审批人");
            return
          }
        }else {
          apprpArr = item.ApprovalMemberList.map(i => {
            return i.UserID
          })
          haveApr = true
        }
        let ccArr = []
        ccArr = item.CcMemberList.map(j => {
          return j.UserID
        })
        return {
          NodeType: item.NodeType,
          ApprovalFlowNodeName: item.WorkFlowNodeName,
          ApprovalMemberRoleID: item.ApprovalMemberRoleID,
          ApprovalMemberType: item.ApprovalMemberType,
          ApprovalMode: item.ApprovalMode,
          IsApprovalMySelf: item.IsApprovalMySelf,
          IsApprovalComplete: item.IsApprovalComplete,
          ApprovalUsers: apprpArr,
          CCUsers: ccArr
        }
      })
      for(let i=0,len=arr.length;i<len;i++){
        if(arr[i]===undefined){
          Toast.fail("请设置审批人");
            return false
        }
      }
      let picArr = [];
      picArr = this.fileList.map(item => {
            return item.upUrl;
      })
      if (haveApr) {
        let res = await this.xyapi.post(this.$store.state.apiPath + "/api/TeacherLeaveForMobile/CreateTeacherLeave",
          {
            // TeacherLeaveTypeID: this.leaveId,
            // StartTime: this.startMsg,
            // EndTime: this.endMsg,
            // ApplicationDescription: this.description,
            // LeavePictrueList: picArr,
            // ApprovalModel: obj

            ApplicationState: 1,
            TeacherLeaveTypeID: this.leaveId,
            StartTime: this.startMsg,
            EndTime: this.endMsg,
            ApplicationDescription: this.description,
            LeavePictrueList: picArr,
            Models: arr
          }
        )
        if (res.success) {
          Toast.success("请假成功")
          this.$router.push(`/home/TeacherLeave/myLeave`);
        }
      }
    },
    imgList_delete(){
      this.filesArr = JSON.parse(JSON.stringify(this.fileList))
    }
  }
};
</script>
<style lang="less" scoped>
.creat{
  width: 100%;
  min-height: 736px;
  overflow: scroll;
}
.van-cell {
  padding: 30px 36px;
  &.flexColumn {
    flex: none;
    flex-direction: column;
    padding-top: 10px;
    & > .van-cell__title {
      width: 100%;
    }
    & > .van-cell__value {
      width: 100%;
      overflow:visible;
      margin-top: 15px;
    }
  }
}
.leaveType {
  width: 100%;
  height: 100%;
  li {
    display: block;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
}
.bottom-btn {
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 99;
  background: #fff;
  box-shadow: 0 2px 21px 0 rgba(186, 186, 186, 0.44);
  .van-button {
    display: block;
    width: 22%;
    height: 80px;
    line-height: 80px;
    color: #fff;
    font-weight: 700;
    font-size: 30px;
    font-weight: 400;
    margin: 10px auto 15px;
    text-align: center;
    border-radius: 45px;
    background: #4196ff !important;
  }
}
</style>
